import jQuery from "jquery";

export default function(buttonSelector) {
  const button = jQuery(buttonSelector);
  return () => {
    button.hide();
  }
}
